import React from "react";
import { EditableImg, useInspectorControl } from "@smartfire/gutenberg-react";
import {
  defineBlock,
  smartProps,
  useSmartProp,
} from "@smartfire/gutenberg-react";
import style from "./block.module.scss";
import {
  PanelBody,
  PanelRow,
  ToggleControl,
  SelectControl,
} from "@wordpress/components";
import { ReactComponent as BackImg } from "./logo_dark.svg";

function Inspector() {
  const [dark, setDark] = useSmartProp("dark");
  const [borders, setBorders] = useSmartProp("borders");
  const [backImg, setBackImg] = useSmartProp("backImg");

  return (
    <>
      <PanelBody title="Configuration" initialOpen={true}>
        <PanelRow>
          <SelectControl
            label="Fond gris"
            options={[
              { label: "Vide", value: "empty" },
              { label: "Moitié", value: "half" },
              { label: "Plein", value: "full" },
            ]}
            value={dark}
            onChange={(value) => setDark(value)}
          />
        </PanelRow>
        <PanelRow>
          <ToggleControl
            label="Bords bleus"
            checked={borders}
            onChange={(value) => setBorders(value)}
          />
        </PanelRow>
        <PanelRow>
          <ToggleControl
            label="Logo en fond"
            checked={backImg}
            onChange={(value) => setBackImg(value)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ dark, borders, backImg }) {
  useInspectorControl(Inspector);

  return (
    <div className={style.block}>
      <div className={style.content}>
        {backImg && <BackImg className={style.backImg} />}
        <div className={style.grid}>
          <div className={style.leftCol}>
            <div className={style.image}>
              <EditableImg smartProp="img1" />
            </div>
            {borders && <div className={style.square} />}
          </div>
          <div className={style.rightCol}>
            <div className={style.image}>
              <EditableImg smartProp="img2" />
            </div>
            {borders && <div className={style.square} />}
          </div>
        </div>
      </div>
      {dark === "full" && <div className={style.greyBackgroundFull} />}
      {dark === "half" && <div className={style.greyBackgroundHalf} />}
    </div>
  );
}

export default defineBlock({
  Block,
  setup: {
    title: "2 Images",
  },
  smartProps: {
    img1: smartProps.any.withDefault(),
    img2: smartProps.any.withDefault(),
    dark: smartProps.string.withDefault("empty"),
    borders: smartProps.bool.withDefault(false),
    backImg: smartProps.bool.withDefault(false),
  },
});
